





































































































































































































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { mapActions, mapGetters, mapState } from 'vuex';
import MarkdownText from '@/components/ui/MarkdownText.vue';
import ReservationDetails from '@/components/ReservationDetails.vue';
import ReservationLocation from '@/components/ReservationLocation.vue';
import TermsAgreement from '@/components/TermsAgreement.vue';
import portalMixin from '@/mixins/portalMixin';
import ReservationStepMixin from '@/mixins/reservationStepMixin';
import Customer from '@/models/Customer';
import Quote from '@/models/Quote';
import Reservation from '@/models/Reservation';
import ReservationService from '@/services/ReservationService';
import { getOrString } from '@/utilities/helpers';

const Setup = Vue.extend({
	name: 'ReservationSummary',
	inject: ['$validator'],
	components: {
		MarkdownText,
		ReservationDetails,
		ReservationLocation,
		TermsAgreement,
	},
	props: {
		active: Boolean,
	},
	computed: {
		...mapState(['paths', 'termsOfService']),
		...mapGetters(['customer']),
		...mapState('reservation', [
			'originalReservation',
			'reservation',
		]),
		...mapGetters('location', [
			'address',
			'location',
			'locationName',
			'settings',
		]),
		...mapGetters('reservation', [
			'customer',
			'isEditable',
			'isExistingReservation',
			'isModified',
			'quote',
			'reprintLink',
		]),
	},
	methods: {
		...mapActions('reservation', ['saveReservation']),
	},
});

@Component
export default class ReservationSummary extends mixins(Setup, portalMixin, ReservationStepMixin) {
	// Props
	public active!: boolean;

	public isNewReservation: boolean = true;
	public cancelError: string = '';
	public emailed = false;
	public isLoading = false;
	public showAgreement = false;

	// State
	public paths!: { [path: string]: string };
	public reservation!: Reservation;
	public termsOfService!: string;

	// Getters
	public address!: string;
	public customer!: Customer;
	public isEditable!: boolean;
	public isExistingReservation!: boolean;
	public isModified!: boolean;
	public location!: Locations.Location;
	public locationName!: string;
	public settings!: Locations.Settings;
	public quote!: Quote;
	public reprintLink!: string;

	// Actions
	public saveReservation!: () => Promise<any>;

	public created() {
		if (!this.reservation.auto_key) {
			this.isNewReservation = true;
		}
	}

	// Methods
	public agreeToTerms() {
		console.log('Agreed To Terms...');
		this.$validator.validateAll().then(async (result: boolean) => {
			if (!result) {
				return;
			}

			if (this.termsOfService) {
				this.showAgreement = true;
			} else {
				this.submit(true);
			}
		});
	}

	public async cancelReservation(confirm = false) {
		if (confirm !== true) {
			this.$modal.show('CancelModal');
		}

		if (confirm === true) {
			this.$modal.hide('CancelModal');

			try {
				this.isLoading = true;
				await ReservationService.cancelReservation(
					this.reservation.uid,
					this.location.codeID as string,
				);
				window.location.reload();
			} catch (error) {
				this.cancelError = getOrString('response.data.errors.0.text', error);
				setTimeout(() => {
					this.cancelError = '';
				}, 5000);
			}

			this.isLoading = false;
		}
	}

	public async emailReservation() {
		try {
			this.isLoading = true;
			this.emailed = false;

			await ReservationService.emailReservation(
				this.location.codeID as string,
				this.reservation.uid,
			);

			this.emailed = true;

			setTimeout(() => {
				this.emailed = false;
			}, 4000);
		} catch (error) {
			/* Error */
		}

		this.isLoading = false;
	}

	public async submit(agreed: boolean) {
		if (!agreed) {
			return;
		}

		if (!await this.$validator.validateAll()) {
			return;
		}

		this.isLoading = true;
		try {
			await this.saveReservation();

			if (this.isNewReservation) {
				const bookEvent = document.createEvent('Event');
				bookEvent.initEvent('booked', true, true);
				document.dispatchEvent(bookEvent);
			}

			if (!this.isNewReservation) {
				window.location.reload();
			}

			this.$store.commit('clearErrors');
			this.isLoading = false;
			this.setStep(this.Step.Confirmation);
		} catch (errors) {
			const e = errors.errors;
			if (e.length > 0 && e[0].text.includes('already another reservation')) {
				this.$modal.show('DuplicateModal');
			}

			this.isLoading = false;
		}
	}

	public uxAction() {
		this.$store.dispatch('analytics/action', {
			type: 'UX',
			label: 'click',
			value: 'View Terms and Book',
			step: this.$store.state.reservation.step,
		} as Analytics.ActionParams);
	}
}
